import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export const participantRoot = (union: boolean) =>
  union ? '/highLevelTournaments/participation' : '/tournaments/participation';
export const participantPages = (union: boolean): Record<string, string> =>
  union
    ? {
        squad: '/highLevelTournaments/teams',
        'squad/manage': '/highLevelTournaments/teams/edit',
        'squad/recruit': '/highLevelTournaments/teams/recruit',
        'squad/schools': '/highLevelTournaments/teams/schools',
        'squad/players': '/highLevelTournaments/teams/players',
        events: '/highLevelTournaments/events',
        schools: '/highLevelTournaments/athleteSchools',
        'schools/availability': '/highLevelTournaments/availability',
        'schools/notifications': '/highLevelTournaments/athleteSchools/notifications',
        'schools/notification': '/highLevelTournaments/athleteSchools/notification'
      }
    : {
        squad: '/tournaments/teams',
        'squad/manage': '/tournaments/teamPlayers/manage',
        'squad/players': '/tournaments/teamPlayers',
        events: '/tournaments/events'
      };

// Existing editors keep their established location contracts, while browser URLs
// and editor-to-editor navigation stay inside the participant workspace.
export function participantDestination(destination: any, union: boolean, tournamentId: string, state: any) {
  const url = typeof destination === 'string' ? new URL(destination, 'http://local') : null;
  const target = url ? { pathname: url.pathname, search: url.search, hash: url.hash } : { ...destination };
  const page = Object.keys(participantPages(union)).find(key => participantPages(union)[key] === target.pathname);
  if (!page) return destination;
  const query = new URLSearchParams(target.search || '');
  if (!query.get('tournamentId')) query.set('tournamentId', tournamentId);
  return {
    ...target,
    pathname: `${participantRoot(union)}/${page}`,
    search: `?${query}`,
    state: { ...state, ...target.state }
  };
}

export function getParticipationSummary(user: AppUser, tournamentId: string) {
  return axios
    .get(`${window.apiBase}/i/schools/${user.activeSchoolId}/tournaments/${tournamentId}/participation-summary`, {
      headers: { usid: user.roleSessionKey }
    })
    .then(response => response.data);
}
